import { useCallback } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material//CheckCircleOutlineRounded';
import DoNotDisturbAltRoundedIcon from '@mui/icons-material/DoNotDisturbAltRounded';
import Button from '@mui/material/Button';
import { isFunction } from 'lodash';

interface Props {
    isConfirmed: boolean;
    onConfirm?: (isConfirmed: boolean) => void;
}

export const AppointmentDetailsConfirmed = ({ isConfirmed, onConfirm }: Props) => {
    const handleConfirm = useCallback(() => {
        if (isFunction(onConfirm)) onConfirm(true);
    }, [onConfirm]);

    const handleDecline = useCallback(() => {
        if (isFunction(onConfirm)) onConfirm(false);
    }, [onConfirm]);

    return (
        <Grid container>
            <Grid item xs={4} lg={3}>
                <Typography fontWeight={500}>Confirmed</Typography>
            </Grid>
            <Grid item xs={8} lg={9}>
                <Box display="flex" alignItems="center" gap={1}>
                    {isConfirmed ? (
                        <>
                            <CheckCircleOutlineRoundedIcon color="success" />
                            <Typography color="success">Yes</Typography>{' '}
                            {isFunction(onConfirm) && (
                                <Button variant="contained" color="warning" onClick={handleDecline}>
                                    Decline
                                </Button>
                            )}
                        </>
                    ) : (
                        <>
                            <DoNotDisturbAltRoundedIcon color="error" />
                            <Typography color="error">No</Typography>
                            {isFunction(onConfirm) && (
                                <Button variant="contained" onClick={handleConfirm}>
                                    Confirm
                                </Button>
                            )}
                        </>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};
